import * as S from './RoomInclusionslListComponent.styles';
import {defaultTheme} from '@stencil/build-theme';
import {BaseColumnWrap} from '../../../../CommonStyleUtils/dwebCommon.styles';

export default function RoomInclusionsListComponent({
  inclusions_list = [],
  isGoTribeSuperStar = false,
}) {
  return (
    <>
      <S.CancelList_Wrap>
        {inclusions_list.map((item, index) => (
          <li key={index}>
            <S.Left_wrap />
            <BaseColumnWrap>
              <S.Text_Head
                dangerouslySetInnerHTML={{
                  __html: item?.text || '',
                }}
              />
              <S.Sub_Text_Head
                dangerouslySetInnerHTML={{
                  __html: item?.subText || '',
                }}
              />
            </BaseColumnWrap>
          </li>
        ))}
        {isGoTribeSuperStar && (
          <S.Superstar_OuterWrap>
            <S.Left_wrap />
            <BaseColumnWrap>
              <S.Superstar_tag>
                <S.SuperStarImg src="https://gos3.ibcdn.com/gotribedwebsuperstar-1617263701.png" />
                Complimentary Room Upgrade
              </S.Superstar_tag>
              <S.Sub_Text_Head>
                As goTribe superstar member and get Free complimentary room upgrade, subject to
                availability. Name of room - next category.
              </S.Sub_Text_Head>
            </BaseColumnWrap>
          </S.Superstar_OuterWrap>
        )}
      </S.CancelList_Wrap>
    </>
  );
}
